const handleFormData = (oldData, formVal) => {
  let addList = []; //作为新增的规则列表
  for (let key in formVal) {
    // key = key.replace('@','')
    const arr = key.split('-') || [undefined, undefined];
    const proty = arr[0];
    const ids = arr[1];
    if (formVal[key]) {
      if (proty) {
        let i = '';
        oldData.forEach((item, index) => {
          if (JSON.stringify(item.id) === ids) {
            i = index;
          }
        });
        //判断没有数据是取值报错
        if (oldData.length && i !== '') {
          oldData[i][proty.replace(/@|&/g, '')] = formVal[key];
        }
      }
    }
    if (ids.indexOf('null') !== -1) {
      const addIndex = ids.slice(4);
      if (addList[addIndex]) {
        addList[addIndex][proty.replace(/@|&/g, '')] = formVal[key];
      } else {
        let a = {
          id: null,
        };
        a[proty.replace(/@|&/g, '')] = formVal[key];
        a[addIndex] = addIndex;
        addList.push(a);
      }
    }
  }

  if (addList.length) {
    oldData.push(...addList);
  }
  return oldData;
};

const handleMultipleFormData = (oldData, formVal) => {
  let addList = []; //作为新增的规则列表
  for (let key in formVal) {
    const arr = key.split('-') || [undefined, undefined];
    const proty = arr[0];
    const ids = arr[1];
    if (formVal[key]) {
      if (proty) {
        let i = '';
        oldData.forEach((item, index) => {
          if (JSON.stringify(item.relationId) === ids) {
            i = index;
          }
        });
        if (oldData.length && i !== '') {
          //初始时候旧数据判空
          oldData[i][proty.replace(/@|&/g, '')] = formVal[key];
        }
      }
    }
    if (ids.indexOf('null') !== -1) {
      const addIndex = ids.slice(4);
      if (addList[addIndex]) {
        addList[addIndex][proty.replace(/@|&/g, '')] = formVal[key];
      } else {
        let a = {
          id: null,
        };
        a[proty.replace(/@|&/g, '')] = formVal[key];
        a[addIndex] = addIndex;
        addList.push(a);
      }
    }
  }
  if (addList.length) {
    oldData.push(...addList);
  }
  //对平铺结构变换成层级结构
  let newData = [];
  oldData.forEach((item, index) => {
    let newOneList = {};

    let firstobj = {};

    let secondobj = {};

    for (let key in item) {
      const arr = key.split('_') || [undefined, undefined];
      const i = arr[0];
      const proty = arr[1];
      if (i === 'first' && proty) {
        firstobj[proty.replace(/@|&/g, '')] = item[key];
      } else if (i === 'second' && proty) {
        secondobj[proty.replace(/@|&/g, '')] = item[key];
      }
      if (!item.relationId) {
        //如果为新增的则会设置默认值
        if (item['first_conditionType'] === 'COMBINE') {
          firstobj['relationOperator'] = 'EQ';
          firstobj['value'] = 'TRUE';
          firstobj['valueType'] = 'CONSTANT';
        }
        if (item['second_conditionType'] === 'COMBINE') {
          secondobj['relationOperator'] = 'EQ';
          secondobj['value'] = 'TRUE';
          secondobj['valueType'] = 'CONSTANT';
        }
      } else {
        newOneList['relationId'] = item.relationId;
      }
      newOneList['firstCondition'] = firstobj;
      newOneList['secondCondition'] = secondobj;
    }
    newOneList['logicalOperator'] = item.logicalOperator;
    newOneList['relationNo'] = item.relationNo ? item.relationNo : index + 1;

    newData.push(newOneList);
  });
  return newData;
};
// //判断多层级对象含有的某个字段是否为空
// const hasUndefInObj = (obj, cons) => {
//   console.log('0909obj',obj)
//   let ishave = false;
//   for (let key in obj) {
//     if (obj[key] instanceof Object) {
//       ishave = hasUndefInObj(obj[key],cons);
//     } else if (String(obj[key]) === String(cons)) {
//       ishave = true;
//       return;
//     }
//   }
//   return ishave;
// };
//判断多层级对象含有的某个字段是否为空 针对两级
const hasUndefInObj = (obj, cons) => {
  let ishave = false;
  for (let key in obj) {
    if (obj[key] instanceof Object) {
      ishave = hasUndefInObj(obj[key], cons);
      for (let keys in obj[key]) {
        if (String(obj[key][keys]) === String(cons)) {
          ishave = true;
          return ishave;
        }
      }
    } else if (String(obj[key]) === String(cons)) {
      ishave = true;
      return ishave;
    }
  }
  return ishave;
};

// 对Form某些固定值进行初始化

// 规则管理的如果切换select必填判断
const selectChangeIsRequired = (formVal) => {
  let isRequire = false;
  for (let key in formVal) {
    if (formVal[key]) {
      const arr = key.split('-') || [undefined, undefined];
      const proty = arr[0];
      const ids = arr[1];
      // 规则管理单个的验证
      if (proty === 'conditionType' && formVal[key] === 'EXTERNAL_INPUT') {
        if (formVal['condition@-' + ids] === undefined) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'conditionType' && formVal[key] === 'FIELD') {
        if (formVal['condition-' + ids] === undefined) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'valueType' && formVal[key] === 'VARIABLE') {
        if (!formVal['value-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'valueType' && formVal[key] === 'CONSTANT') {
        if (!formVal['value@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      // 规则管理多个的验证(左条件)
      if (
        proty === 'first_conditionType' &&
        formVal[key] === 'EXTERNAL_INPUT'
      ) {
        if (!formVal['first_condition@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'first_conditionType' && formVal[key] === 'FIELD') {
        if (!formVal['first_condition-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'first_conditionType' && formVal[key] === 'COMBINE') {
        if (!formVal['first_condition&-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'first_valueType' && formVal[key] === 'CONSTANT') {
        if (!formVal['first_value@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'first_valueType' && formVal[key] === 'VARIABLE') {
        if (!formVal['first_value-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      // 规则管理多个的验证(右条件)
      if (
        proty === 'second_conditionType' &&
        formVal[key] === 'EXTERNAL_INPUT'
      ) {
        if (!formVal['second_condition@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'second_conditionType' && formVal[key] === 'FIELD') {
        if (!formVal['second_condition-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'second_conditionType' && formVal[key] === 'COMBINE') {
        if (!formVal['second_condition&-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'second_valueType' && formVal[key] === 'CONSTANT') {
        if (!formVal['second_value@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'second_valueType' && formVal[key] === 'VARIABLE') {
        if (!formVal['second_value-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      // 快捷规则管理
      if (proty === 'scoreType') {
        if (!formVal['score-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      // 临时变量
      if (proty === 'variableType1' && formVal[key] === 'SYSTEM') {
        if (!formVal['element1@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'variableType1' && formVal[key] === 'TEMPORARY') {
        if (!formVal['element1-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'variableType2' && formVal[key] === 'SYSTEM') {
        if (!formVal['element2@-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
      if (proty === 'variableType2' && formVal[key] === 'TEMPORARY') {
        if (!formVal['element2-' + ids]) {
          isRequire = true;
        }
        return isRequire;
      }
    }
  }
};

export {
  handleFormData,
  handleMultipleFormData,
  hasUndefInObj,
  selectChangeIsRequired,
};
